/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Education_QuestionInputs */

const en_onboarding_education_question = /** @type {(inputs: Onboarding_Education_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where are you in your education?`)
};

const es_onboarding_education_question = /** @type {(inputs: Onboarding_Education_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿En qué etapa de tu educación estás?`)
};

/**
* | output |
* | --- |
* | "Where are you in your education?" |
*
* @param {Onboarding_Education_QuestionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_education_question = /** @type {((inputs?: Onboarding_Education_QuestionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Education_QuestionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_education_question(inputs)
	return en_onboarding_education_question(inputs)
});